// pages/admin/ArticlesPage.jsx
import React from 'react';
import AdminPanel from '../../components/Admin/AdminPanel';

const ArticlesPage = () => {
  return <AdminPanel />;
};

export default ArticlesPage;